import { mdlServiceResponse } from "../models/service-models/common/ServiceResponse";
import { mdlParameterDetailRequest } from "../models/service-models/parameter/ParameterDetailRequest";
import { mdlParameterDetailResponse } from "../models/service-models/parameter/ParameterDetailResponse";
import { mdlParameterListRequest } from "../models/service-models/parameter/ParameterListRequest";
import { mdlParameterListResponse } from "../models/service-models/parameter/ParameterListResponse";
import { mdlParameterUpdateRequest } from "../models/service-models/parameter/ParameterUpdateRequest";
import { mdlParameterUpdateResponse } from "../models/service-models/parameter/ParameterUpdateResponse";
import { GetResponse } from "../utils/ApiClient";

module ParameterService {
    export async function List(
        pRequest: mdlParameterListRequest
    ): Promise<mdlServiceResponse<mdlParameterListResponse>> {
        return await GetResponse<mdlServiceResponse<mdlParameterListResponse>>(
            "parameter/list",
            pRequest
        );
    }
    export async function Detail(
        pRequest: mdlParameterDetailRequest
    ): Promise<mdlServiceResponse<mdlParameterDetailResponse>> {
        return await GetResponse<mdlServiceResponse<mdlParameterDetailResponse>>(
            "parameter/detail",
            pRequest
        );
    }
    export async function Update(
        pRequest: mdlParameterUpdateRequest
    ): Promise<mdlServiceResponse<mdlParameterUpdateResponse>> {
        return await GetResponse<mdlServiceResponse<mdlParameterUpdateResponse>>(
            "parameter/update",
            pRequest
        );
    }
}
export { ParameterService };
